import { AppLocalEnum } from '@/translate/text';

export const formatDate = (date, includeTime = false, lang = AppLocalEnum.EN) => {
  if (!date) return '';

  const d = date instanceof Date ? date : new Date(date);

  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...(includeTime && {
      hour: '2-digit',
      minute: '2-digit',
    }),
  };
  const locale = lang === AppLocalEnum.AR ? AppLocalEnum.AR : AppLocalEnum.EN_US;
  return d.toLocaleDateString(locale, options);
};
export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return null;
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const toLocalDateTimeInputValue = (date) => {
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().slice(0, 16);
};

export const formatTime = (time, includeTime = false, lang = AppLocalEnum.EN) => {
  if (!time) return '';
  const t = time instanceof Date ? time : new Date(time);
  const options = {
    hour: '2-digit',
    minute: '2-digit',
  };
  return t.toLocaleTimeString(lang, options);
};

const cairoOffsetMs = (at) => {
  const name = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Africa/Cairo',
    timeZoneName: 'shortOffset',
  })
    .formatToParts(at)
    .find((p) => p.type === 'timeZoneName')?.value;
  const match = name?.match(/GMT([+-]\d+)/);
  return (match ? Number(match[1]) : 2) * 3600000;
};

export const getAppointmentStart = (ticket) => {
  if (!ticket?.appointment_date || !ticket?.time) return null;
  const baseDate = ticket.appointment_date?.toDate?.() || new Date(ticket.appointment_date);
  if (isNaN(baseDate.getTime())) return null;

  const match = ticket.time.match(/(\d+):(\d+)\s*(AM|PM)?/i);
  if (!match) return null;
  let hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const modifier = match[3]?.toUpperCase();
  if (modifier === 'PM' && hours < 12) hours += 12;
  if (modifier === 'AM' && hours === 12) hours = 0;

  const cairoDate = new Date(baseDate.getTime() + cairoOffsetMs(baseDate));
  const wallClock = Date.UTC(cairoDate.getUTCFullYear(), cairoDate.getUTCMonth(), cairoDate.getUTCDate(), hours, minutes);
  const guess = new Date(wallClock - cairoOffsetMs(new Date(wallClock)));
  const start = new Date(wallClock - cairoOffsetMs(guess));
  return isNaN(start.getTime()) ? null : start;
};
